import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs'

// Define all filter parsers - align with useInvoiceQuery expected parameters
const areaFilterParsers = {
  // Search query
  search: parseAsString.withDefault('').withOptions({
    clearOnDefault: true,
  }),

  // Status filters
  isActive: parseAsArrayOf(parseAsString, ',')
    .withDefault(['all'])
    .withOptions({
      clearOnDefault: true,
    }),

  type: parseAsArrayOf(parseAsString, ',').withDefault(['all']).withOptions({
    clearOnDefault: true,
  }),
}

export function useAreaFilters() {
  const [filters, setFilters] = useQueryStates(areaFilterParsers, {
    history: 'replace', // Use replace to avoid cluttering browser history
    shallow: true, // Client-side only updates
  })

  // Helper functions for easier state management
  const updateSearch = (search: string) => {
    setFilters({ ...filters, search })
  }

  const updateAreaType = (types: string[]) => {
    setFilters({ ...filters, type: types })
  }

  const updateAreaStatus = (statuses: string[]) => {
    setFilters({ ...filters, isActive: statuses })
  }

  const clearAllFilters = () => {
    setFilters({
      search: '',
      isActive: ['all'],
      type: ['all'],
    })
  }

  // Check if any filters are active (excluding defaults)
  const hasActiveFilters =
    filters.search !== '' ||
    !filters.isActive.includes('all') ||
    !filters.type.includes('all')

  return {
    // Current filter values
    filters,

    // Update functions
    updateSearch,
    setFilters,
    clearAllFilters,
    updateAreaType,
    updateAreaStatus,
    hasActiveFilters,
  }
}

// Type exports for better TypeScript support
export type AreaFilters = ReturnType<typeof useAreaFilters>['filters']
export type AreaFilterKey = keyof typeof areaFilterParsers
